import React from 'react';
import ReactTable, { Filter } from 'react-table';
import 'react-table/react-table.css';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { IPractitioner } from '../../../modules/unsw-fhir/Practitioner';
import { getFirstName, getLastName } from '../../../selectors/practitioner';

const PractitionersTable = ({
  practitioners,
  organizationId,
  loading,
  onFetchData,
  filtered,
  page,
  pages,
}: {
  practitioners: IPractitioner[];
  organizationId?: string;
  loading?: boolean;
  page?: number;
  pages?: number;
  onFetchData?: (state: any, instance: any) => void;
  filtered?: Filter[];
}) => (
  <ReactTable
    loading={loading}
    showPageSizeOptions={false}
    showFilters={false}
    showPageJump={false}
    page={page}
    pages={pages}
    data={practitioners}
    filtered={filtered}
    onFetchData={onFetchData}
    columns={[
      {
        Header: 'First Name',
        id: 'firstName',
        accessor: props => getFirstName(props),
      },
      {
        Header: 'Last Name',
        id: 'lastName',
        accessor: props => getLastName(props),
      },
      {
        Cell: props => {
          const { value } = props;
          return (
            <div>
              <Button
                disabled={!organizationId}
                block
                tag={Link}
                to={`/organization/${organizationId}/practitioner/${value}`}>
                View
              </Button>
            </div>
          );
        },
        accessor: d => d.id,
        id: 'buttons',
        resizable: false,
        sortable: false,
        maxWidth: 200,
      },
    ]}></ReactTable>
);
export default PractitionersTable;
